import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { SensorElementConfig } from "./types.js";

export const soilTemperatureElementConfig: SensorElementConfig<
    Record<string, never>,
    typeof SensorConversions.unity
> = {
    legalConvertedRange: [-50, 100],
    conversionKey: "unity",
    parameterConfigs: {},
    buildConversionParams: () => ({}),
    decodedUnits: "celsius",
    convertedUnits: "celsius",
    unitCategory: "soilTemperature",
    testCases: [
        { parameters: {}, decodedValue: 20, convertedValue: 20 },
        { parameters: {}, decodedValue: -5, convertedValue: -5 },
    ],
} as const;
